// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HXe6F4wQUQhBf5lPZVnO{grid-template-columns:1fr auto;align-items:center;gap:16px;padding:12px 0;display:grid}.oYmfxBuyznwTliWgc4GQ{flex-direction:column;gap:4px;display:flex}.oprtCQmZIt83hh9rIart{align-items:center;min-height:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `HXe6F4wQUQhBf5lPZVnO`,
	"labelContainer": `oYmfxBuyznwTliWgc4GQ`,
	"selectContainer": `oprtCQmZIt83hh9rIart`
};
export default ___CSS_LOADER_EXPORT___;
